/**
 * Mount element IDs for client-side hydration
 * Using const assertion for type safety and autocomplete
 */
export const MountIds = {
  GEO_IP_BAR: 'mount-geo-ip-bar',
  VAT_SELECTION_BAR: 'mount-vat-selection-bar',
  LANGUAGE_BAR: 'mount-language-bar',
  VAT_TOGGLE: 'mount-vat-toggle',
  SEARCH_BAR: 'mount-search-bar',
  CART: 'mount-cart',
  MY_ACCOUNT: 'mount-my-account',
  COUNTRY_SELECTOR_DESKTOP: 'country-selector-button-desktop',
  COUNTRY_SELECTOR_MOBILE: 'country-selector-button-mobile',
  FOOTER_NAVIGATION: 'mount-footer-navigation',
  NP_ABSOLUTE_GUARANTEE: 'mount-np-absolute-guarantee',
  DESKTOP_NAVIGATION: 'mount-desktop-navigation',
  MOBILE_MENU: 'mount-mobile-menu',
  FAVORITES_HEADER: 'mount-favorites-header',
  GOOGLE_ONE_TAP: 'mount-google-one-tap',
  MY_PROJECTS: 'mount-my-projects',
  HELP_LINK: 'mount-help-link',
  BRAND_PILLARS_CAROUSEL: 'mount-brand-pillars-carousel',
} as const

export type MountId = (typeof MountIds)[keyof typeof MountIds]

/**
 * VAT placement options for the VAT toggle component
 */
export const VatPlacement = {
  BRAND_BANNER: 'BrandBanner',
} as const

export type VatPlacementType = (typeof VatPlacement)[keyof typeof VatPlacement]
